module.exports = __webpack_public_path__ + "img/off.abed6731.svg";